import { crudTable, date, index, integer, real } from "@-/dev.improve.haniverse.lib.database.table";
import { sql } from "@-/com.npmjs.drizzle-orm";

export const fsrsCardReviewLogTable = crudTable(
  "fsrs_card_review_log",
  {
    difficulty: real("difficulty").notNull(), // Difficulty of the card before the review
    due: date("due").notNull(), // Date of the last scheduling
    elapsedDays: integer("elapsed_days").notNull(), // Number of days elapsed since the last review
    lastElapsedDays: integer("last_elapsed_days").notNull(), // Number of days between the last two reviews
    learningSteps: integer("learning_steps").notNull(), // Keeps track of the current step during the (re)learning stages
    rating: integer("rating").notNull(), // Rating of the review (Again, Hard, Good, Easy)
    review: date("review").notNull(), // Date of the review
    scheduledDays: integer("scheduled_days").notNull(), // Number of days until the next review
    stability: real("stability").notNull(), // Stability of the card before the review
    state: integer("state").notNull(), // State of the review (New, Learning, Review, Relearning)
  },
  // Covering partial index for the learning-stats read
  // (`use-learning-stats-query.ts`), which does an unfiltered `findMany` — the
  // soft-delete proxy injects `WHERE deleted_at IS NULL`, but with no index that
  // was a `SCAN (Full Table)` on every card reveal (a write to any watched actor
  // table refetches the stats). The partial index restricts to the live rows the
  // read wants and covers its selected columns (`rating`, `review`), so the scan
  // is over a compact index instead of the full row heap.
  (table) => [
    index("fsrs_card_review_log_active_idx")
      .on(table.rating, table.review)
      .where(sql`${table.deletedAt} is null`),
  ],
);

export type FsrsCardReviewLog = typeof fsrsCardReviewLogTable.$inferSelect;
